import { ReactNode, FC } from 'react';

import styles from './ChartTabs.module.scss';

type TabProps = {
  label: ReactNode;
  value: string;
  onClick?: () => void;
  className?: string;
  'data-testid'?: string;
  active?: boolean;
  index: number;
};

export const ChartTab: FC<TabProps> = ({
  label,
  value,
  onClick,
  className = '',
  'data-testid': testId,
  active,
  index,
}) => (
  <button
    type="button"
    className={`${styles.tab} ${active ? styles.active : ''} ${className}`}
    onClick={onClick}
    data-value={value}
    data-testid={testId}
    data-index={index}
    data-palette="ChartTab">
    {label}
  </button>
);
